import React from "react";
import PropTypes from "prop-types";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  makeStyles,
} from "@material-ui/core";
import translate from "i18n/translate";
import CommonHeaders from "./CommonHeaders";
import { SrCurrency } from "../../../../common";
import { DISTRIBUTOR_TYPE } from "../constants";

const DETAIL_TABLE_ROWS = ["calculated", "notCalculated", "total"];

export const useStyles = makeStyles((theme) => ({
  row: {
    "& td": {
      fontSize: theme.typography.pxToRem(13),
    },
  },
  selectable: {
    cursor: "pointer",
  },
}));

const DetailTable = ({ detailData, onClose, type }) => {
  const classes = useStyles();
  const availableRows = detailData.notCalculated.operations
    ? DETAIL_TABLE_ROWS
    : [DETAIL_TABLE_ROWS[0]];

  return (
    <TableContainer>
      <Table>
        <TableHead className={classes.selectable} onClick={onClose}>
          <TableRow>
            <CommonHeaders isDetailTable type={type} />
          </TableRow>
        </TableHead>
        <TableBody>
          {availableRows.map((rowId) => (
            <TableRow key={rowId} className={classes.row}>
              <TableCell>{translate(`distributors.${rowId}`)}</TableCell>
              <TableCell>{detailData[rowId].operations}</TableCell>
              <TableCell>
                <SrCurrency value={detailData[rowId].transacted} />
              </TableCell>

              <TableCell>
                <SrCurrency value={detailData[rowId].commisions} />
              </TableCell>
              {type === DISTRIBUTOR_TYPE.master && (
                <>
                  <TableCell>
                    <SrCurrency value={detailData[rowId].cost} />
                  </TableCell>
                  <TableCell>
                    {isNaN(detailData[rowId].net) ? (
                      detailData[rowId].net
                    ) : (
                      <SrCurrency value={detailData[rowId].net} />
                    )}
                  </TableCell>
                </>
              )}
              <TableCell>
                {isNaN(detailData[rowId].distributor) ? (
                  detailData[rowId].distributor
                ) : (
                  <SrCurrency value={detailData[rowId].distributor} />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

DetailTable.propTypes = {
  detailData: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default DetailTable;
